var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var UIModelHubUsers = /** @class */ (function () {
    function UIModelHubUsers(response) {
        this.list = response.users
            ? response.users.map(function (user) { return new UIModelHubUser(user); })
            : [];
        this.total = response.total;
    }
    return UIModelHubUsers;
}());
export { UIModelHubUsers };
var UIModelHubUser = /** @class */ (function () {
    function UIModelHubUser(params) {
        this.update(params);
    }
    UIModelHubUser.prototype.update = function (params) {
        this.id = params.id;
        this.name = params.name;
        this.email = params.email;
        this.emailVerified = params.emailVerified;
        this.picture = params.picture;
        this.createdAt = new Date(params.createdAt);
        this.blocked = params.blocked;
        this.createdBy = {
            userId: params.createdBy.userId,
            userName: params.createdBy.userName,
        };
        (this.modifiedAt = new Date(params.modifiedAt)),
            (this.modifiedBy = {
                userId: params.modifiedBy.userId,
                userName: params.modifiedBy.userName,
            });
        this.permissions = params.permissions;
        this.roles = params.roles;
    };
    Object.defineProperty(UIModelHubUser.prototype, "primaryRole", {
        // Helper method to get the primary role for display
        get: function () {
            var e_1, _a;
            if (this.roles && this.roles.length > 0) {
                // Return the first role or prioritize certain roles
                var priorityOrder = [
                    "partner-owner",
                    "partner-perf-msg-specialist",
                    "partner-member",
                    "client-owner",
                    "client-perf-msg-specialist",
                    "client-member",
                ];
                try {
                    for (var priorityOrder_1 = __values(priorityOrder), priorityOrder_1_1 = priorityOrder_1.next(); !priorityOrder_1_1.done; priorityOrder_1_1 = priorityOrder_1.next()) {
                        var priority = priorityOrder_1_1.value;
                        if (this.roles.includes(priority)) {
                            return priority;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (priorityOrder_1_1 && !priorityOrder_1_1.done && (_a = priorityOrder_1.return)) _a.call(priorityOrder_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return this.roles[0];
            }
            return "partner-member"; // fallback
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(UIModelHubUser.prototype, "displayRole", {
        // Helper method to display role in a user-friendly format
        get: function () {
            var role = this.primaryRole;
            switch (role) {
                case "partner-owner":
                    return "Partner Owner";
                case "partner-member":
                    return "Partner Member";
                case "partner-perf-msg-specialist":
                    return "Partner Performance Messaging Specialist";
                case "client-owner":
                    return "Client Owner";
                case "client-member":
                    return "Client Member";
                case "client-perf-msg-specialist":
                    return "Client Performance Messaging Specialist";
                default:
                    return role.replace("-", " ").replace(/\b\w/g, function (l) { return l.toUpperCase(); });
            }
        },
        enumerable: false,
        configurable: true
    });
    return UIModelHubUser;
}());
export { UIModelHubUser };
//# sourceMappingURL=data:application/json;base64,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